const Logo = (props) => (
  <img alt="Logo" src="../static/images/logo_edeka.svg" {...props} />);
  
export default Logo;
